import { useTranslation } from 'react-i18next'

import { EnvironmentOverlay as SharedEnvironmentOverlay } from '@percent/shared/environment-overlay'
import { environment } from '@percent/admin-dashboard/config'
import { environments } from '@percent/admin-dashboard/constants/environments'

/** The shared overlay, in the admin dashboard's own words and translations. */
export function EnvironmentOverlay() {
  const { t } = useTranslation()

  return (
    <SharedEnvironmentOverlay
      environment={environment}
      label={
        environment === environments.SANDBOX
          ? t('typography.usingPercentSandbox')
          : t('typography.environment', { environment })
      }
    />
  )
}
